export default "__VITE_ASSET__f1a5e190__"